import Locale from '~/locale/locale'

export enum Terms {
    Documents = 'documents',
}

export const defaultLocale = Locale.en_GB

type LocalisedDocument = Partial<{[key in Locale]: string}>

export type LocalisedDocuments = {
    masterServiceAgreement: LocalisedDocument
    dataProcessingAgreement: LocalisedDocument
    privacyPolicy: LocalisedDocument
    purchaseTerms: LocalisedDocument
}

export type TermsConfig = {
    [Terms.Documents]: LocalisedDocuments
}
